export default "__VITE_ASSET__fyQIuAov__"